import React from "react";

import { Box, Flex, Divider } from "flicket-ui";
import Image from "~components/common/Image";
import EventInformation from "../events.EventInformation";
import {
  PageContext,
  isOnsaleCompetitionContext,
  isRegistrationCompetitionContext,
} from "~features/events/hooks/useDetailsPageContext";
import EventCTACard from "../events.EventCTACard";
import { competitionClosesText } from "~features/events/utils/competition";
import CompetitionDetails from "../CompetitionDetails/CompetitionDetails";
import { EventPreviewModeBanner } from "~features/events/components/EventDetails/event.PreviewModeBanner";

type MobileDetailProps = {
  pageContext: PageContext;
};

export const Mobile = ({ pageContext }: MobileDetailProps) => {
  const { event } = pageContext;
  const { title, logo } = event;

  const hasContentAboveEventInformation =
    logo ||
    isRegistrationCompetitionContext(pageContext) ||
    isOnsaleCompetitionContext(pageContext);

  return (
    <Flex flexDir="column" px={2} pb={5} overflowY="auto" flex="1">
      <Box flex="1" mt={hasContentAboveEventInformation ? 0 : 4}>
        <EventPreviewModeBanner />
        {logo && <Image alt={title} mt={4} image={logo} />}

        {isRegistrationCompetitionContext(pageContext) ||
        isOnsaleCompetitionContext(pageContext) ? (
          <EventCTACard
            mt={logo ? 5 : 0}
            title={pageContext.competition?.title}
            image={pageContext.competition?.prizes?.[0].image}
            imageAlt={pageContext.competition?.title}
            footer={competitionClosesText(pageContext.competition)}
          />
        ) : null}

        {hasContentAboveEventInformation ? <Divider my={4} /> : null}
        <EventInformation event={event} mb={5} />
        {isOnsaleCompetitionContext(pageContext) ||
        isRegistrationCompetitionContext(pageContext) ? (
          <CompetitionDetails competition={pageContext.competition} />
        ) : null}
      </Box>
    </Flex>
  );
};
